import React from "react";
import './Aboutus.css';
import axios from 'axios';
import Breadcrumb from '../Components/Breadcrumb';
class Privacypolicy extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            privacypolicy : []
        }
    }; 
    componentDidMount(){
      axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/resource/Web Page/Privacy-policy'), {
          headers : {'Authorization' : process.env.REACT_APP_TOKEN, 
      'content-type': 'application/json'}
      })
      .then(response=>{
          this.setState({privacypolicy:response.data['data']})
          //console.log(response.data.data)  
      })
      .catch(response=>{
           //console.log(response+' api/resource/Item?fields=["name","item_group","standard_rate","image","description","item_code","item_name"]')
      })
  } 
  render() {
        const rawHTML =this.state.privacypolicy.main_section_html

    return <div>
           <Breadcrumb head="Privacy Policy"/>
    <section className="about-area mtb-50px">
    <div className="container">
        <div className="row"dangerouslySetInnerHTML={{ __html: rawHTML }}/>
    </div>
  </section>
  
</div>
}
}

export default Privacypolicy;